import {
  provideTransloco,
  TranslocoLoader,
  TranslocoModule,
} from '@jsverse/transloco';
import { isDevMode, NgModule } from '@angular/core';
import { provideEaiDesignSystemI18n } from '@corvus-it-poland/eai-design-system';
import { provideEaiReportsI18n } from '@corvus-it-poland/eai-reports';
import { provideEaiChatI18n } from '@corvus-it-poland/eai-chat';
import { of } from 'rxjs';

class EmptyTranslocoLoader implements TranslocoLoader {
  getTranslation() {
    return of({});
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'pl'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          logMissingKey: true,
        },
      },
      loader: EmptyTranslocoLoader,
    }),
    provideEaiDesignSystemI18n(),
    provideEaiReportsI18n(),
    provideEaiChatI18n(),
  ],
})
export class TranslocoRootModule {}
